import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Star } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AdminTestimonials = () => {
    const [items, setItems] = useState([]);
    const [form, setForm] = useState({ author: "", location: "", project: "", rating: 5, text: "" });
    const [busy, setBusy] = useState(false);

    const load = () =>
        axios.get(`${API}/testimonials`).then((r) => setItems(r.data.testimonials || [])).catch(() => {});

    useEffect(() => { load(); }, []);

    const add = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await axios.post(`${API}/admin/testimonials`, { ...form, rating: Number(form.rating) });
            setForm({ author: "", location: "", project: "", rating: 5, text: "" });
            toast.success("Avis publié sur la page d'accueil");
            load();
        } catch (err) {
            toast.error(err.response?.data?.detail || "Erreur de publication");
        } finally {
            setBusy(false);
        }
    };

    const del = async (id) => {
        await axios.delete(`${API}/admin/testimonials/${id}`).catch(() => {});
        toast.success("Avis supprimé");
        load();
    };

    return (
        <div className="space-y-6">
            <form onSubmit={add} className="lux-card p-6 space-y-3">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
                    <input data-testid="testimonial-author" className="lux-input" placeholder="Nom du client *"
                        value={form.author} onChange={(e) => setForm({ ...form, author: e.target.value })} required />
                    <input data-testid="testimonial-location" className="lux-input" placeholder="Ville"
                        value={form.location} onChange={(e) => setForm({ ...form, location: e.target.value })} />
                    <input data-testid="testimonial-project" className="lux-input" placeholder="Type de projet"
                        value={form.project} onChange={(e) => setForm({ ...form, project: e.target.value })} />
                    <select data-testid="testimonial-rating" className="lux-input" value={form.rating}
                        onChange={(e) => setForm({ ...form, rating: e.target.value })}>
                        <option value="5">5 étoiles</option>
                        <option value="4">4 étoiles</option>
                        <option value="3">3 étoiles</option>
                        <option value="2">2 étoiles</option>
                        <option value="1">1 étoile</option>
                    </select>
                </div>
                <textarea data-testid="testimonial-text" className="lux-input w-full" rows={3}
                    placeholder="Témoignage du client * (min. 10 caractères)"
                    value={form.text} onChange={(e) => setForm({ ...form, text: e.target.value })} required minLength={10} />
                <button data-testid="testimonial-add" type="submit" disabled={busy} className="btn-champagne disabled:opacity-50">
                    Publier l'avis
                </button>
            </form>

            <div className="space-y-3">
                {items.map((t) => (
                    <div key={t.id} className="lux-card p-5 flex justify-between items-start gap-4 flex-wrap">
                        <div className="min-w-0">
                            <div className="flex items-center gap-2">
                                <span className="font-serif-lux text-lg">{t.author}</span>
                                <span className="flex gap-0.5">
                                    {Array.from({ length: t.rating || 5 }).map((_, i) => (
                                        <Star key={i} size={12} className="fill-[#B89C6A] text-[#B89C6A]" />
                                    ))}
                                </span>
                            </div>
                            <div className="text-[12px] text-[#B89C6A] mt-0.5">{[t.project, t.location].filter(Boolean).join(" · ")}</div>
                            <p className="text-[13px] text-[#1C1E1D]/70 mt-2">« {t.text} »</p>
                        </div>
                        <button data-testid={`testimonial-delete-${t.id}`} onClick={() => del(t.id)}
                            className="text-[11px] tracking-wider uppercase text-red-700/70 hover:text-red-700 underline shrink-0">
                            Supprimer
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
};
